import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  numberAttribute
} from '@angular/core';

/**
 * Circular progress indicator with an optional percentage label in the centre.
 *
 * Sized from `size` alone: the radius, stroke and label all scale with it, so
 * callers only pick a diameter.
 */
@Component({
  selector: 'umss-progress-ring',
  standalone: true,
  templateUrl: './progress-ring.component.html',
  styleUrl: './progress-ring.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssProgressRingComponent {
  /** Completion from 0 to 100. Values outside that range are clamped. */
  value = input.required<number, number>({ transform: numberAttribute });
  /** Diameter in pixels. */
  size = input(40, { transform: numberAttribute });
  strokeWidth = input(3, { transform: numberAttribute });
  showLabel = input(true, { transform: booleanAttribute });

  protected readonly percent = computed(() =>
    Math.min(Math.max(this.value(), 0), 100)
  );

  protected readonly center = computed(() => this.size() / 2);
  protected readonly radius = computed(
    () => this.center() - this.strokeWidth() / 2
  );
  protected readonly circumference = computed(
    () => 2 * Math.PI * this.radius()
  );

  /** Length of track left unfilled — how the arc is drawn. */
  protected readonly dashOffset = computed(
    () => this.circumference() * (1 - this.percent() / 100)
  );

  protected readonly viewBox = computed(() => `0 0 ${this.size()} ${this.size()}`);
}
